// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"d6a9913c","496":"0976b2b7"}[chunkId] + ".chunk.js";
};